import { Link } from "react-router-dom";
import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import { SectionCard } from "shared/app/SectionCard";
import { BrandingPreview } from "shared/app/BrandingForm/BrandingPreview";
import { useAuthContext } from "providers/Auth";
import { Property } from "types/landlord/address";
import {
  COMMUNITY_PARAM,
  SEARCH_PARAM
} from "views/settings-branding/constants";

// Branding is edited on Settings → Branding; this section only shows what the
// Community renders and where it comes from.
export const BrandingSection = ({ property }: { property: Property }) => {
  const { type } = useAuthContext();
  const summary = property.branding_summary;
  if (!summary) return null;

  const isCustom = summary.status === "custom";
  const settingsLink = `/settings/branding?${new URLSearchParams({
    [COMMUNITY_PARAM]: String(property.id),
    [SEARCH_PARAM]: property.name
  })}`;

  return (
    <SectionCard
      title="Branding"
      headerExtra={
        <Badge
          size={BadgeSize.SM}
          variant={isCustom ? BadgeVariant.PRIMARY : BadgeVariant.BASE}
        >
          {isCustom ? "Custom branding" : "Company branding"}
        </Badge>
      }
      footer={
        <Show if={type.adminPrivileges}>
          <div className="flex items-center justify-end w-full">
            <Link
              to={settingsLink}
              className="text-base font-bold text-primary-600"
            >
              Manage in Settings → Branding
            </Link>
          </div>
        </Show>
      }
    >
      <div className="space-y-4">
        <p className="text-sm text-content-200">
          {isCustom
            ? "This Community has its own branding override."
            : "This Community uses the company branding."}
        </p>
        <BrandingPreview branding={summary.resolved} />
      </div>
    </SectionCard>
  );
};
